//  $(document).ready(function() {
  //   var descElement = $('.collection-header-block .banner-highlight .desc');
  //   var descText = descElement.text();
  //   var maxWidth = $('.collection-header-block .banner-highlight .desc').outerWidth(true)-20;
  //   var lineHeight = parseInt(descElement.css('line-height'));
  //   var maxLines = 10;
  //   var truncatedText = descText;
    
  //   // 计算每行的最大字符数
  //   var charsPerLine = Math.floor(maxWidth / (parseInt(descElement.css('font-size')) / 2));
    
    
    
  //   // 清空原始文本
  //   descElement.empty();
    
  //   // 分割文本为三行
  //   var words = truncatedText.split(' ');
  //   var lineText = '';
  //   var lineCount = 0;
  //   var spanCount = 0;
    
  //   for (var i = 0; i < words.length; i++) {
  //     var word = words[i];
  //     var tempText = lineText + word;
      
  //     // 检查是否超出行宽
  //     if (tempText.length <= charsPerLine) {
  //       lineText = tempText + ' ';
  //     } else {
  //       // 创建每行的 span 元素，并添加到 desc 元素中
  //       var spanElement = $('<span>').text(lineText.trim());
  //       descElement.append(spanElement);
        
  //       // 添加换行符
  //       if (lineCount < maxLines - 1) {
  //         descElement.append('<br>');
  //       }
        
  //       lineText = word + ' ';
  //       lineCount++;
  //       spanCount++;
        
      
  //     }
  //   }
    
  //   // 添加最后一行的 span 元素
  //   var lastLineElement = $('<span>').text(lineText.trim());
  //   descElement.append(lastLineElement);
  //   let seeMoreLinkStatus=$('.see-more-link').length>0;
  //   // 检查 span 的数量并添加 .see-more-link
  //   if (spanCount >= maxLines) {
  //     // 在第三个 span 后面添加 .see-more-link
  //     var seeMoreLink = $('.see-more-link');
  //     descElement.find('span:last-child').after(seeMoreLink);
  //     // descElement.find('span:eq(2)').addClass('more-span');
  //     if(seeMoreLinkStatus){
  //       descElement.find('span:last-child').addClass('has-link-span');
  //     }
  //     if (lineCount >= maxLines && !seeMoreLinkStatus) {
  
  //       console.log(lastLineElement,seeMoreLinkStatus,"seeMoreLinkStatus");
        
        
  //       descElement.find('span:last-child').append('...');
  //           }
  //   } else {
  //     // 在最后一个 span 添加 .see-more-link
  //     var seeMoreLink = $('.see-more-link');
  //     lastLineElement.after(seeMoreLink);
  //     lastLineElement.addClass('more-span'); 
  //     if(seeMoreLinkStatus){
  //       lastLineElement.addClass('has-link-span');
  //     }
     
  //   }
  // });
  
  
  
  function sortBy(that){
   $(that).addClass("selected").siblings().removeClass("selected");
  }
  
  function sortByResult(){
    let href= $(".nt_ajaxsortby a.selected").data("href");
    console.log(href);
    window.location.href=href;
  }
   
   
  $(document).on('click', function(event) {
    var targetElement = $(event.target);
    
    if (!targetElement.closest('.nt_ajaxsortby').length) {
      $(".cat_sortby").removeClass("opended");
    }
  });
  
  
  // 移动端筛选弹窗
  function closeMbFilter(){ 
    console.log(23234343);
    $(".template-collection button.mfp-close").click();
  }
   
  let mbFilterStatus=true;
  function openMbFilter(){
   
    if(mbFilterStatus){
      console.log("1212121212");
      $("#shopify-section-sidebar_shop2 .cat_fixcl-scroll").append($(".popup-filter-btn-box"));
      setTimeout(function(){
        $(".collection-fiter-mb-title-box").append($(".template-collection .mfp-ready .mfp-close"));
      },200)
      mbFilterStatus=false;
    }
   
  }
   